import React, { useEffect, Fragment, memo, useState, useRef } from "react";
import {
  Navbar,
  Container,
  Nav,
  Dropdown,
  Form,
  Button,
  Image,
  Modal,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import CustomToggle from "../../../dropdowns";
import logo from "../../../../assets/images/coyote-logo.jpg";

//img
import shapes1 from "../../../../assets/images/shapes/01.png";
import shapes2 from "../../../../assets/images/shapes/02.png";
import shapes3 from "../../../../assets/images/shapes/03.png";
import shapes4 from "../../../../assets/images/shapes/04.png";
import avatars1 from "../../../../assets/images/avatars/01.png";
import { roleTypes } from "../../../../data/roleType";
// Import selectors & action from setting store
import * as SettingSelector from "../../../../store/setting/selectors";
import url from "../../../../configs/config";
import axios from "axios";
import AlertNotificationSimple from "../../../alert/alert-notification-simple";
import { useDispatch } from "react-redux";

// import state selectors
import { fetchPermissionsData } from "../../../../store/setting/actions";

const Header = memo((props) => {
  const alertRef = useRef(null);
  const [errors, setErrors] = useState({});
  const navbarHide = useSelector(SettingSelector.navbar_show); // array
  const headerNavbar = useSelector(SettingSelector.header_navbar);
  const [decodedToken, setDecodedToken] = useState();
  const [userRolesWarehouses, setUserRolesWarehouses] = useState([]);
  const [warehouse, setWarehouse] = useState();
  const [role, setRole] = useState();
  const [warehouseName, setWarehouseName] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  // const [warehouses, setWarehouses] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = localStorage.getItem("coyote-token");
  const [alert, setAlert] = useState({
    message: "",
    type: "",
    show: false,
    alertFor: "",
  });
  const decodeToken = (token) => {
    try {
      return jwtDecode(token);
    } catch (error) {
      return null;
    }
  };

  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const selectedWarehouse = userRolesWarehouses.find(
    (wh) => wh.warehouseId === warehouse
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    setDecodedToken(decodeToken(token)?.user);
  }, [token]);

  useEffect(() => {
    if (decodedToken && token) {
      if (
        decodedToken?.roles?.some((r) => r.role_type === roleTypes.WAREHOUSE)
      ) {
        const getUserRolesWarehouses = async () => {
          try {
            const config = {
              headers: {
                Authorization: `${token}`,
              },
            };
            const response = await axios.get(
              `${url.backendURL}user/roles-warehouses`,
              config
            );
            setUserRolesWarehouses(response.data.response.data);
          } catch (err) {
            handleError(err, "role-switch-submit");
          }
        };
        setWarehouse(decodedToken?.warehouse_id);
        getRolesForWarehouse(decodedToken?.warehouse_id);
        getUserRolesWarehouses();
      }
    }
  }, [decodedToken, token]);

  const handleError = (err, alertFor) => {
    const { response } = err;
    if (alertRef.current) {
      alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    if (response.data.error === "jwt expired" || response?.data?.error === "Unauthorized. User not found") {
      localStorage.removeItem("coyote-token");
      navigate(
        `/${
          decodedToken?.roles?.some(
            (role) => role.role_type === roleTypes.SUPER_ADMIN
          )
            ? "admin"
            : "user"
        }/auth/sign-in`,
        {
          state: { status: "expired" },
        }
      );
      setDecodedToken(undefined);
    } else {
      const responseErrors = response?.data?.error || {};
      setErrors(responseErrors);
      setAlert({
        message: response ? response.data.message : "An error occurred",
        type: "danger",
        show: true,
        alertFor,
      });
      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
      }, 5000);
    }
  };
  const logoutUser = () => {
    localStorage.removeItem("coyote-token");
    navigate(
      `/${
        decodedToken?.roles?.some(
          (role) => role.role_type === roleTypes.SUPER_ADMIN
        )
          ? "admin"
          : "user"
      }/auth/sign-in`
    );
  };

  useEffect(() => {
    // navbarstylemode
    if (headerNavbar === "navs-sticky" || headerNavbar === "nav-glass") {
      window.onscroll = () => {
        if (document.documentElement.scrollTop > 50) {
          document.getElementsByTagName("nav")[0].classList.add("menu-sticky");
        } else {
          document
            .getElementsByTagName("nav")[0]
            .classList.remove("menu-sticky");
        }
      };
    }
  });
  const minisidebar = () => {
    document.getElementsByTagName("ASIDE")[0].classList.toggle("sidebar-mini");
  };

  const goToProfile = async () => {
    navigate("/dashboard/app/user-profile", {
      state: { profileData: "first" },
    });
  };

  const handleApply = () => {
    if (Number(decodedToken?.warehouse_id) !== Number(warehouse)) {
      setShowConfirmModal(true);
    }
  };

  const confirmSwitch = async () => {
    try {
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };

      const response = await axios.post(
        `${url.backendURL}user/switch-role`,
        { warehouseId: warehouse },
        config
      );
      if (alertRef.current) {
        alertRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      setErrors({});
      setAlert({
        message: response.data.message,
        type: "success",
        show: true,
        alertFor: "role-switch-submit",
      });

      const message = `Profile switched successfully! You are now assigned to the <strong>${warehouseName}</strong>.`;
      setSuccessMessage(message);
      setShowConfirmModal(false);
      localStorage.setItem("coyote-token", response.data.response.jwt);
      dispatch(fetchPermissionsData());
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (err) {
      handleError(err, "role-switch-submit");
    }
  };

  const [warehouseRoles, setWarehouseRoles] = useState("");

  const handleWarehouseChange = (selectedWarehouse) => {
    setWarehouse(selectedWarehouse);
  };
  useEffect(() => {
    if (warehouse) {
      getRolesForWarehouse(warehouse);
    }
  }, [warehouse]);

  const getRolesForWarehouse = async (selectedWarehouse) => {
    const warehouseData = userRolesWarehouses?.find(
      (w) => Number(w.warehouseId) === Number(selectedWarehouse)
    );
    setWarehouseName(warehouseData?.warehouseName);
    setWarehouseRoles(
      warehouseData?.roles?.map((role) => role.roleName).join(" | ") ||
        decodedToken?.roles?.map((role) => role.name).join(" | ") ||
        "No roles assigned"
    );
  };

  const handleSelect = async (warehouseId) => {
    await handleWarehouseChange(warehouseId);
    setIsOpen(false);
  };

  return (
    <Fragment>
      <Navbar
        expand="lg"
        variant="light"
        className={`nav iq-navbar ${headerNavbar} ${navbarHide.join(
          " "
        )} fixed-top-mobile`}
      >
        <div className="container mt-4">
          {successMessage && (
            <div
              className="alert alert-success alert-dismissible fade show position-fixed start-50 translate-middle-x text-center"
              style={{
                top: "20px",
                width: "50%",
                zIndex: 1050,
              }}
              role="alert"
            >
              <strong>Success!</strong>{" "}
              <span
                dangerouslySetInnerHTML={{
                  __html: successMessage,
                }}
              />
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="alert"
                aria-label="Close"
                onClick={() => setSuccessMessage("")}
              ></button>
            </div>
          )}
        </div>

        <Container fluid className="navbar-inner">
          <Link to="/dashboard" className="navbar-brand">
            {/* <Logo color={true} /> */}
            <Image
              src={logo}
              className="logo-title"
              style={{ width: "100%", height: "30px" }}
              alt="coyote-logo"
            />
            {/* <h4 className="logo-title">Coyote OS</h4> */}
          </Link>
          <div
            className="sidebar-toggle"
            data-toggle="sidebar"
            data-active="true"
            onClick={minisidebar}
          >
            <i className="icon" style={{ transform: "rotate(360deg)" }}>
              <svg
                width="20px"
                id="icon-rotate"
                height="20px"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"
                />
              </svg>
            </i>
          </div>

          <Navbar.Toggle aria-controls="navbarSupportedContent">
            <span className="navbar-toggler-icon">
              <span className="mt-2 navbar-toggler-bar bar1"></span>
              <span className="navbar-toggler-bar bar2"></span>
              <span className="navbar-toggler-bar bar3"></span>
            </span>
          </Navbar.Toggle>
          <Navbar.Collapse id="navbarSupportedContent">
            <Nav
              as="ul"
              className="mb-2 ms-auto navbar-list mb-lg-0 align-items-center"
            >
              <Dropdown as="li" className="nav-item">
                <Dropdown.Toggle
                  as={CustomToggle}
                  variant=" nav-link py-0 d-flex align-items-center"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img
                    id="profilePicHeader"
                    src={
                      decodedToken?.profile_picture
                        ? `${decodedToken?.profile_picture}`
                        : avatars1
                    }
                    alt="User-Profile"
                    className="img-fluid avatar avatar-50 avatar-rounded"
                  />

                  <div className="caption ms-3 d-none d-md-block ">
                    <h6 className="mb-0 caption-title text-capitalize">
                      <span id="profileNameHeader">{decodedToken?.name}</span>
                    </h6>
                    <p className="mb-0 caption-sub-title text-capitalize">
                      {decodedToken?.warehouse
                        ? decodedToken.warehouse.length > 15
                          ? decodedToken.warehouse.slice(0, 15) + "..."
                          : decodedToken.warehouse
                        : decodedToken?.roles?.some(
                            (role) => role.role_type === roleTypes.SUPER_ADMIN
                          )
                        ? "Super Admin"
                        : decodedToken?.roles?.some(
                            (role) => role.role_type === roleTypes.ADMIN
                          )
                        ? "Admin"
                        : decodedToken?.roles?.[0]?.name}
                    </p>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  className="dropdown-menu-end"
                  aria-labelledby="navbarDropdown"
                >
                  <Dropdown.Item onClick={() => goToProfile()}>
                    Profile
                  </Dropdown.Item>

                  {decodedToken?.roles?.some(
                    (role) =>
                      role.role_type !== roleTypes.SUPER_ADMIN &&
                      decodedToken?.warehouse_id
                  ) && (
                    <>
                      <Dropdown as="li" className="nav-item">
                        <Dropdown.Toggle
                          variant="mx-0 ms-3 px-0 py-0 d-flex align-items-center"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          id="roleDropdown"
                          className="mb-0 caption-sub-title text-capitalize"
                        >
                          {decodedToken?.warehouse?.length > 13 &&
                            decodedToken?.warehouse.slice(0, 13)}
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                          className="p-3 dropdown-menu-end"
                          style={{ minWidth: "250px" }}
                        >
                          <div className="mb-3">
                            <h6 className="mb-2">Warehouse</h6>
                            <div className="mb-3">
                              <div
                                className="position-relative"
                                ref={dropdownRef}
                              >
                                <button
                                  type="button"
                                  className="btn btn-outline-secondary w-100 d-flex justify-content-between align-items-center"
                                  onClick={() => setIsOpen(!isOpen)}
                                  style={{
                                    height: "44px",
                                    textAlign: "left",
                                    border: "1px solid #ced4da",
                                    borderRadius: "6px",
                                    backgroundColor: "#ffffff",
                                    fontSize: "15px",
                                    padding: "0 12px",
                                    transition: "all 0.15s ease",
                                    boxShadow: isOpen
                                      ? "0 0 0 0.2rem rgba(13, 110, 253, 0.15)"
                                      : "none",
                                    borderColor: isOpen ? "#0d6efd" : "#ced4da",
                                  }}
                                >
                                  <span
                                    className={
                                      selectedWarehouse
                                        ? "text-dark"
                                        : "text-muted"
                                    }
                                  >
                                    {selectedWarehouse
                                      ? selectedWarehouse?.warehouseName
                                          .length > 13
                                        ? selectedWarehouse.warehouseName.slice(
                                            0,
                                            13
                                          ) + "..."
                                        : selectedWarehouse.warehouseName
                                      : "Choose a warehouse..."}
                                  </span>
                                  <span
                                    className="text-muted"
                                    style={{
                                      transform: isOpen
                                        ? "rotate(180deg)"
                                        : "rotate(0deg)",
                                      transition: "transform 0.2s ease",
                                    }}
                                  >
                                    ▼
                                  </span>
                                </button>

                                {isOpen && (
                                  <div
                                    className="position-absolute w-100 bg-white border rounded shadow-lg"
                                    style={{
                                      top: "100%",
                                      left: 0,
                                      zIndex: 1050,
                                      maxHeight: "200px",
                                      overflowY: "auto",
                                      borderRadius: "6px",
                                      border: "1px solid #dee2e6",
                                      marginTop: "2px",
                                    }}
                                  >
                                    {userRolesWarehouses.map((wh) => (
                                      <span
                                        key={wh.warehouseId}
                                        title={wh.warehouseName}
                                      >
                                        <button
                                          type="button"
                                          className="btn btn-link w-100 text-start border-0 rounded-0"
                                          disabled={
                                            wh.warehouseStatus === "in-active"
                                          }
                                          onClick={() =>
                                            handleSelect(wh.warehouseId)
                                          }
                                          title={wh.warehouseName}
                                          style={{
                                            padding: "10px 16px",
                                            fontSize: "15px",
                                            color:
                                              wh.warehouseStatus === "in-active"
                                                ? "#6c757d"
                                                : "#212529",
                                            fontStyle:
                                              wh.warehouseStatus === "in-active"
                                                ? "italic"
                                                : "normal",
                                            backgroundColor:
                                              warehouse === wh.warehouseId
                                                ? "#e7f3ff"
                                                : "transparent",
                                            borderBottom: "1px solid #f1f3f4",
                                            textDecoration: "none",
                                            textWrap: "nowrap",
                                          }}
                                          onMouseEnter={(e) => {
                                            if (
                                              wh.warehouseStatus !== "in-active"
                                            ) {
                                              e.target.style.backgroundColor =
                                                warehouse === wh.warehouseId
                                                  ? "#e7f3ff"
                                                  : "#f8f9fa";
                                            }
                                          }}
                                          onMouseLeave={(e) => {
                                            e.target.style.backgroundColor =
                                              warehouse === wh.warehouseId
                                                ? "#e7f3ff"
                                                : "transparent";
                                          }}
                                        >
                                          <span title={wh.warehouseName}>
                                            {wh.warehouseName.length > 13
                                              ? wh.warehouseName.slice(0, 13) +
                                                "..."
                                              : wh.warehouseName}
                                          </span>
                                          {wh.warehouseStatus ===
                                            "in-active" && (
                                            <span className="text-muted ms-2">
                                              (Inactive)
                                            </span>
                                          )}
                                        </button>
                                      </span>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="mb-3">
                            <h6 className="mb-2">Role(s)</h6>
                            {warehouseRoles}
                          </div>
                          <Button
                            variant="primary"
                            className="w-100"
                            onClick={handleApply}
                            disabled={
                              !warehouse ||
                              Number(decodedToken?.warehouse_id) ===
                                Number(warehouse)
                            }
                          >
                            Apply
                          </Button>
                        </Dropdown.Menu>
                      </Dropdown>
                      <Modal
                        show={showConfirmModal}
                        onHide={() => setShowConfirmModal(false)}
                      >
                        <Modal.Header className="custom-modal-header">
                          <Modal.Title>Confirm Warehouse Switch</Modal.Title>
                          <button
                            type="button"
                            className="btn-close-svg"
                            onClick={() => setShowConfirmModal(false)}
                            aria-label="Close"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                            >
                              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                            </svg>
                          </button>
                        </Modal.Header>

                        {/* <AlertNotificationSimple
                      type={alert.type}
                      message={alert.message}
                      show={alert.show}
                      onClose={() => setAlert({ ...alert, show: false })}
                    /> */}

                        <Modal.Body>
                          <div className="mb-3">
                            <p>Are you sure you want to switch?</p>
                            <div className="alert alert-warning">
                              <strong>Warning:</strong> You will be logged out
                              of your current warehouse
                              <b className="text-danger text-capitalize">
                                {" "}
                                {decodedToken?.warehouse}{" "}
                              </b>{" "}
                              and switched to
                              <b className="text-primary text-capitalize">
                                {" "}
                                {warehouseName}{" "}
                              </b>{" "}
                            </div>
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            onClick={() => setShowConfirmModal(false)}
                          >
                            Cancel
                          </Button>
                          <Button variant="primary" onClick={confirmSwitch}>
                            Confirm Switch
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </>
                  )}
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={logoutUser}>Logout</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Fragment>
  );
});

export default Header;
